import { IonIcon } from "@ionic/react";
import imgPlus from "../media/square-plus-regular.svg";

const PlusIcon = () => {
	return <IonIcon icon={imgPlus} color="primary" slot="icon-only" />;
};

export default PlusIcon;
